import React, { useState } from 'react';
import { Menu, Dropdown, Button, Popconfirm } from 'antd';
import { CSVLink } from 'react-csv';
import { Container, Menus } from './styles';
import { LoadingOutlined, TableOutlined } from '@ant-design/icons';
import exportFromJSON from 'export-from-json';

interface IExportBtn {
  screenData: any;
  filename: string;
  onGetAllData: () => Promise<any>;
}

export const ExportBtn: React.FC<IExportBtn> = ({ onGetAllData, filename, screenData }) => {
  const [loading, setLoading] = useState(false);
  const exportType = 'xls';

  async function fullTable() {
    setLoading(true);
    const allData = await onGetAllData();
    const fileName = `${filename}-completa`;
    exportFromJSON({ data: allData, fileName, exportType });
    setLoading(false);
  }

  function currentTable() {
    const fileName = `${filename}-pagina`;
    exportFromJSON({ data: screenData, fileName, exportType });
  }

  const menuDropDown = (
    <Menus>
      <Menu.Item>
        <Popconfirm
          cancelButtonProps={{ type: 'primary' }}
          title={'Como deseja exportar a tabela?'}
          okText="Página Atual"
          cancelText="Completa"
          placement="leftTop"
          onConfirm={currentTable}
          onCancel={fullTable}
        >
          <Button type="link">XLS - Excel</Button>
        </Popconfirm>
      </Menu.Item>

      <Menu.Item>
        <Button type="link">
          <CSVLink type="link" data={screenData} filename={`${filename}.csv`}>
            CSV
          </CSVLink>
        </Button>
      </Menu.Item>
    </Menus>
  );

  return (
    <Dropdown disabled={loading} overlay={menuDropDown}>
      <Container
        className="outlineBtn"
        icon={loading ? <LoadingOutlined /> : <TableOutlined />}
        onClick={(e) => e.preventDefault()}
      >
        {loading ? 'Aguarde...' : 'Exportar'}
      </Container>
    </Dropdown>
  );
};
